import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnDestroy,
  signal,
} from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { ButtonComponent } from 'mt-ui-lib/components/button';
import { FieldComponent } from 'mt-ui-lib/components/field';
import { InputComponent } from 'mt-ui-lib/components/input';
import { TemporaryPassword } from '@core/interfaces/keycloak-user';
import { MoscowDateTimePipe } from '@shared/components/moscow-time/moscow-date-time.pipe';
import { MoscowTimeZoneBadgeComponent } from '@shared/components/moscow-time/moscow-time-zone-badge.component';

@Component({
  selector: 'app-user-temp-password-dialog',
  imports: [
    MoscowDateTimePipe,
    MoscowTimeZoneBadgeComponent,
    ButtonComponent,
    FieldComponent,
    InputComponent,
  ],
  templateUrl: './user-temp-password-dialog.component.html',
  styleUrls: ['./user-temp-password-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserTempPasswordDialogComponent implements OnDestroy {
  protected readonly data = inject<TemporaryPassword>(DIALOG_DATA);
  protected readonly dialog = inject(DialogRef);
  protected readonly message = signal('');
  protected async copy(): Promise<void> {
    try {
      await navigator.clipboard.writeText(this.data.temporaryPassword);
      this.message.set('Пароль скопирован');
    } catch {
      this.message.set('Не удалось скопировать. Выделите пароль вручную.');
    }
  }
  ngOnDestroy(): void {
    this.data.temporaryPassword = '';
  }
}
